/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-11 14:47:05
 * @LastEditTime: 2022-01-11 16:50:57
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 银联对账汇总详情
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/YLPayOrderSummaryList/detail.jsx
 */




import { Button, Modal, Tabs } from 'antd';
import React, { useState } from 'react'

import ModalScrollContainer from '../../../components/ModalScrollContainer';

import YlPayOrderSummaryDataList from './components/YlPayOrderSummaryDataList';
import YlPayOrderSummaryDataOrderList from './components/YlPayOrderSummaryDataOrderList';

const YLPayOrderSummaryDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [id, setId] = useState(null);
    const open = (id) => {
        setVisible(true)
        setId(id)
    }
    const close = () => {
        setVisible(false)
    }
    
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="对账详情" 
            width={950} 
            visible={visible} 
            onCancel={close} 
            destroyOnClose
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }}>
                <Tabs animated={false}>
                    <Tabs.TabPane key="汇总数据终端明细" tab="汇总数据终端明细">
                        <YlPayOrderSummaryDataList id={id} />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="汇总数据订单明细数据" tab="汇总数据订单明细数据">
                        <YlPayOrderSummaryDataOrderList id={id} />
                    </Tabs.TabPane>
                </Tabs>
            </ModalScrollContainer>
        </Modal>
    )
}

export default YLPayOrderSummaryDetail



// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/YLPayOrderSummaryList/detail.jsx